/**
 * Парсинг UTC timestamp без суффикса 'Z'
 * (бэкенд отдаёт datetime.utcnow().isoformat() без 'Z')
 */
export function parseUtc(ts) {
  if (!ts) return null
  if (!ts.endsWith('Z') && !/[+-]\d{2}:\d{2}$/.test(ts)) {
    return new Date(ts + 'Z')
  }
  return new Date(ts)
}

/**
 * Форматирование длительности в секундах в читаемый вид (рус.)
 */
export function formatDuration(seconds) {
  if (seconds < 60) return `${Math.round(seconds)} сек`
  if (seconds < 3600) {
    const min = Math.floor(seconds / 60)
    const sec = Math.round(seconds % 60)
    return `${min} мин ${sec} сек`
  }
  const hours = Math.floor(seconds / 3600)
  const min = Math.round((seconds % 3600) / 60)
  return `${hours} ч ${min} мин`
}

/**
 * Форматирование даты в ru-RU формат
 */
export function formatDate(date) {
  return new Date(date).toLocaleString('ru-RU')
}

/**
 * Форматирование размера файла
 */
export function formatFileSize(bytes) {
  if (!bytes || bytes === 0) return '0 KB'
  const k = 1024
  const sizes = ['B', 'KB', 'MB', 'GB']
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
}

/**
 * Построение breadcrumb-элементов из пути
 */
export function makeBreadcrumbItems(path) {
  const items = [{ label: 'Корневая папка', path: '/' }]
  if (path && path !== '/') {
    const parts = path.split('/').filter(Boolean)
    parts.forEach((part, idx) => {
      const p = '/' + parts.slice(0, idx + 1).join('/')
      items.push({ label: part, path: p })
    })
  }
  return items
}

/**
 * Получение родительского пути
 */
export function getParentPath(path) {
  const parts = path.split('/').filter(Boolean)
  parts.pop()
  return parts.length > 0 ? '/' + parts.join('/') : '/'
}
